import type { GqlAsset, GqlTemplate } from "./client-gql/types.ts";

type AssetEnvelope = {
    fields: { file: { url: string; title: string } };
} | null;

const toAssetEnvelope = (asset: GqlAsset | null | undefined): AssetEnvelope =>
    asset
        ? {
              fields: {
                  file: {
                      url: asset.url ?? "",
                      title: asset.title ?? ""
                  }
              }
          }
        : null;

const isPresent = <T>(value: T | null | undefined): value is T =>
    value !== null && value !== undefined;

export function mapTemplateItem(item: GqlTemplate): unknown {
    const categories = (item.categoryCollection?.items ?? [])
        .filter(isPresent)
        .map((cat) => ({
            sys: { id: cat.sys.id },
            fields: {
                urlSlug: cat.urlSlug ?? "",
                categoryNameExternal: cat.categoryNameExternal ?? ""
            }
        }));

    const products = (item.productCollection?.items ?? [])
        .filter(isPresent)
        .map((prod) => ({
            sys: { id: prod.sys.id },
            fields: {
                internalTitle: prod.internalTitle ?? "",
                url: prod.url ?? "",
                productNameReference: {
                    fields: {
                        productName:
                            prod.productNameReference?.productName ?? ""
                    }
                },
                icon: toAssetEnvelope(prod.icon)
            }
        }));

    return {
        sys: { id: item.sys.id },
        fields: {
            templateNameInternal: item.templateNameInternal ?? "",
            templateNameExternal: item.templateNameExternal ?? "",
            oneLinerHeadline: item.oneLinerHeadline ?? "",
            fullUrlSlug: item.fullUrlSlug ?? "",
            templateIcon: toAssetEnvelope(item.templateIcon),
            templateThumbnail: toAssetEnvelope(item.templateThumbnail),
            category: categories,
            product: products
        }
    };
}
